import { Container } from 'components/layout';
import styled, { css } from 'styled-components/macro';

import { Flex } from '@olist/united';

export const baseTitleStyle = css`
  font-size: ${({ theme }) => theme.olist.fontSize[`1xsmall`]};
  font-weight: ${({ theme }) => theme.olist.fontWeight.bold};
  line-height: ${({ theme }) => theme.olist.lineHeight.small};
`;

export const TermsOfServiceWrapper = styled(Container)`
  padding-bottom: 150px;
  h1 {
    ${baseTitleStyle}
    margin-bottom: ${({ theme }) => theme.olist.spacing.inline.large};
    margin-top: ${({ theme }) => theme.olist.spacing.inline.large};
    color: ${({ theme }) => theme.olist.color.neutral.stronger};
    font-size: ${({ theme }) => theme.olist.fontSize[`3xlarge`]};
  }
  h2 {
    ${baseTitleStyle}
  }
  p + h2 {
    color: ${({ theme }) => theme.olist.color.primary.base};
    margin-bottom: ${({ theme }) => theme.olist.spacing.inline.medium};
    margin-top: ${({ theme }) => theme.olist.spacing.inline.medium};
  }
  p {
    color: ${({ theme }) => theme.olist.color.neutral.stronger};
    font-weight: ${({ theme }) => theme.olist.fontWeight.regular};
    line-height: ${({ theme }) => theme.olist.lineHeight.small};
    margin: ${({ theme }) => theme.olist.spacing.inline.small} 0;
  }
`;

export const ButtonsWrapper = styled(Flex)`
  background-color: ${({ theme }) => theme.olist.color.neutral.softest};
  bottom: 0;
  box-shadow: ${({ theme }) => theme.olist.shadow.diffuse};
  padding-bottom: ${({ theme }) => theme.olist.spacing.inline.small};
  padding-top: ${({ theme }) => theme.olist.spacing.inline.small};
  position: fixed;
  width: 100%;
`;
